import { render, staticRenderFns } from "./markets.vue?vue&type=template&id=d86659da&"
import script from "./markets.vue?vue&type=script&lang=js&"
export * from "./markets.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {ElementsLoader: require('/var/web/bet777.es/components/elements/loader.vue').default,BetbuilderWrapper: require('/var/web/bet777.es/components/betbuilder/wrapper.vue').default})
